// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ConfirmLineItemsDataQueryVariables = Types.Exact<{
  projectStageId: Types.Scalars['ID']['input'];
}>;


export type ConfirmLineItemsDataQuery = { __typename?: 'Query', projectStage: { __typename?: 'ProjectStage', id: string, homeownerContracts: Array<{ __typename?: 'HomeownerContract', id: string, lineItemsByProjectItem: Array<{ __typename?: 'HomeownerContractLineItemsByProjectItem', projectItem: { __typename?: 'ProjectItem', id: string, name: string, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, costLineItems: Array<{ __typename?: 'CostLineItem', id: string, amountInCents: number, costDate: Types.Scalars['Date']['input'], historicAmountInvoiced: number, isTradePartnerCredit: boolean, entity: { __typename: 'Bill', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } } | { __typename: 'Expense', id: string, description: string, intacctVendorName: string, documents: Array<{ __typename?: 'Document', id: string }> } }> }, lineItems: Array<{ __typename?: 'HomeownerContractLineItem', id: string, priceChangeInCents?: number | null | undefined, owner: { __typename?: 'HomeownerContract', id: string, contractType: Types.ContractType, costPlusMarkupBasisPoints?: number | null | undefined } | { __typename?: 'HomeownerContractChangeOrder', id: string, shortName: string, contractType: Types.ContractType, costPlusMarkupBasisPoints?: number | null | undefined }, invoiceLineItems: Array<{ __typename?: 'InvoiceLineItem', id: string, homeownerContractLineItem: { __typename?: 'HomeownerContractLineItem', id: string }, invoice: { __typename?: 'Invoice', id: string }, costLineItemAllocations: Array<{ __typename?: 'CostLineItemAllocation', id: string, costAmountInCents: number, invoicedAmountInCents: number, costLineItemId: string }> }> }> }> }> } };

export type ConfirmLineItemsHomeownerContractsFragment = { __typename?: 'HomeownerContract', id: string, lineItemsByProjectItem: Array<{ __typename?: 'HomeownerContractLineItemsByProjectItem', projectItem: { __typename?: 'ProjectItem', id: string, name: string, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, costLineItems: Array<{ __typename?: 'CostLineItem', id: string, amountInCents: number, costDate: Types.Scalars['Date']['input'], historicAmountInvoiced: number, isTradePartnerCredit: boolean, entity: { __typename: 'Bill', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } } | { __typename: 'Expense', id: string, description: string, intacctVendorName: string, documents: Array<{ __typename?: 'Document', id: string }> } }> }, lineItems: Array<{ __typename?: 'HomeownerContractLineItem', id: string, priceChangeInCents?: number | null | undefined, owner: { __typename?: 'HomeownerContract', id: string, contractType: Types.ContractType, costPlusMarkupBasisPoints?: number | null | undefined } | { __typename?: 'HomeownerContractChangeOrder', id: string, shortName: string, contractType: Types.ContractType, costPlusMarkupBasisPoints?: number | null | undefined }, invoiceLineItems: Array<{ __typename?: 'InvoiceLineItem', id: string, homeownerContractLineItem: { __typename?: 'HomeownerContractLineItem', id: string }, invoice: { __typename?: 'Invoice', id: string }, costLineItemAllocations: Array<{ __typename?: 'CostLineItemAllocation', id: string, costAmountInCents: number, invoicedAmountInCents: number, costLineItemId: string }> }> }> }> };

export type ConfirmLineItemsHomeownerProjectItemFragment = { __typename?: 'ProjectItem', id: string, name: string, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, costLineItems: Array<{ __typename?: 'CostLineItem', id: string, amountInCents: number, costDate: Types.Scalars['Date']['input'], historicAmountInvoiced: number, isTradePartnerCredit: boolean, entity: { __typename: 'Bill', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } } | { __typename: 'Expense', id: string, description: string, intacctVendorName: string, documents: Array<{ __typename?: 'Document', id: string }> } }> };

export type ConfirmLineItemsHomeownerContractLineItemFragment = { __typename?: 'HomeownerContractLineItem', id: string, priceChangeInCents?: number | null | undefined, owner: { __typename?: 'HomeownerContract', id: string, contractType: Types.ContractType, costPlusMarkupBasisPoints?: number | null | undefined } | { __typename?: 'HomeownerContractChangeOrder', id: string, shortName: string, contractType: Types.ContractType, costPlusMarkupBasisPoints?: number | null | undefined }, invoiceLineItems: Array<{ __typename?: 'InvoiceLineItem', id: string, homeownerContractLineItem: { __typename?: 'HomeownerContractLineItem', id: string }, invoice: { __typename?: 'Invoice', id: string }, costLineItemAllocations: Array<{ __typename?: 'CostLineItemAllocation', id: string, costAmountInCents: number, invoicedAmountInCents: number, costLineItemId: string }> }> };

export type ConfirmLineItemsCostLineItemFragment = { __typename?: 'CostLineItem', id: string, amountInCents: number, costDate: Types.Scalars['Date']['input'], historicAmountInvoiced: number, isTradePartnerCredit: boolean, entity: { __typename: 'Bill', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } } | { __typename: 'Expense', id: string, description: string, intacctVendorName: string, documents: Array<{ __typename?: 'Document', id: string }> } };

export type ConfirmLineItemsCostLineItemEntity_Bill_Fragment = { __typename: 'Bill', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string } };

export type ConfirmLineItemsCostLineItemEntity_Expense_Fragment = { __typename: 'Expense', id: string, description: string, intacctVendorName: string, documents: Array<{ __typename?: 'Document', id: string }> };

export type ConfirmLineItemsCostLineItemEntityFragment = ConfirmLineItemsCostLineItemEntity_Bill_Fragment | ConfirmLineItemsCostLineItemEntity_Expense_Fragment;

export type ConfirmLineItemsCostLineItemAllocationFragment = { __typename?: 'CostLineItemAllocation', id: string, costAmountInCents: number, invoicedAmountInCents: number, costLineItemId: string };

export const ConfirmLineItemsCostLineItemEntityFragmentDoc = gql`
    fragment ConfirmLineItemsCostLineItemEntity on CostLineItemEntity {
  __typename
  ... on Bill {
    id
    name
    tradePartner {
      id
      name
    }
  }
  ... on Expense {
    id
    description
    intacctVendorName
    documents {
      id
    }
  }
}
    `;
export const ConfirmLineItemsCostLineItemFragmentDoc = gql`
    fragment ConfirmLineItemsCostLineItem on CostLineItem {
  id
  amountInCents
  costDate
  historicAmountInvoiced
  isTradePartnerCredit
  entity {
    ...ConfirmLineItemsCostLineItemEntity
  }
}
    ${ConfirmLineItemsCostLineItemEntityFragmentDoc}`;
export const ConfirmLineItemsHomeownerProjectItemFragmentDoc = gql`
    fragment ConfirmLineItemsHomeownerProjectItem on ProjectItem {
  id
  name
  item {
    id
    costCode {
      id
      displayName
    }
  }
  costLineItems {
    ...ConfirmLineItemsCostLineItem
  }
}
    ${ConfirmLineItemsCostLineItemFragmentDoc}`;
export const ConfirmLineItemsCostLineItemAllocationFragmentDoc = gql`
    fragment ConfirmLineItemsCostLineItemAllocation on CostLineItemAllocation {
  id
  costAmountInCents
  invoicedAmountInCents
  costLineItemId
}
    `;
export const ConfirmLineItemsHomeownerContractLineItemFragmentDoc = gql`
    fragment ConfirmLineItemsHomeownerContractLineItem on HomeownerContractLineItem {
  id
  priceChangeInCents
  owner {
    id
    contractType
    costPlusMarkupBasisPoints
    ... on HomeownerContractChangeOrder {
      id
      shortName
    }
  }
  invoiceLineItems {
    id
    homeownerContractLineItem {
      id
    }
    invoice {
      id
    }
    costLineItemAllocations {
      ...ConfirmLineItemsCostLineItemAllocation
    }
  }
}
    ${ConfirmLineItemsCostLineItemAllocationFragmentDoc}`;
export const ConfirmLineItemsHomeownerContractsFragmentDoc = gql`
    fragment ConfirmLineItemsHomeownerContracts on HomeownerContract {
  id
  lineItemsByProjectItem(contractType: COST_PLUS) {
    projectItem {
      ...ConfirmLineItemsHomeownerProjectItem
    }
    lineItems {
      ...ConfirmLineItemsHomeownerContractLineItem
    }
  }
}
    ${ConfirmLineItemsHomeownerProjectItemFragmentDoc}
${ConfirmLineItemsHomeownerContractLineItemFragmentDoc}`;
export const ConfirmLineItemsDataDocument = gql`
    query ConfirmLineItemsData($projectStageId: ID!) {
  projectStage(id: $projectStageId) {
    id
    homeownerContracts {
      ...ConfirmLineItemsHomeownerContracts
    }
  }
}
    ${ConfirmLineItemsHomeownerContractsFragmentDoc}`;

/**
 * __useConfirmLineItemsDataQuery__
 *
 * To run a query within a React component, call `useConfirmLineItemsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfirmLineItemsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfirmLineItemsDataQuery({
 *   variables: {
 *      projectStageId: // value for 'projectStageId'
 *   },
 * });
 */
export function useConfirmLineItemsDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConfirmLineItemsDataQuery, ConfirmLineItemsDataQueryVariables> & ({ variables: ConfirmLineItemsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConfirmLineItemsDataQuery, ConfirmLineItemsDataQueryVariables>(ConfirmLineItemsDataDocument, options);
      }
export function useConfirmLineItemsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfirmLineItemsDataQuery, ConfirmLineItemsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConfirmLineItemsDataQuery, ConfirmLineItemsDataQueryVariables>(ConfirmLineItemsDataDocument, options);
        }
export function useConfirmLineItemsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfirmLineItemsDataQuery, ConfirmLineItemsDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConfirmLineItemsDataQuery, ConfirmLineItemsDataQueryVariables>(ConfirmLineItemsDataDocument, options);
        }
export type ConfirmLineItemsDataQueryHookResult = ReturnType<typeof useConfirmLineItemsDataQuery>;
export type ConfirmLineItemsDataLazyQueryHookResult = ReturnType<typeof useConfirmLineItemsDataLazyQuery>;
export type ConfirmLineItemsDataSuspenseQueryHookResult = ReturnType<typeof useConfirmLineItemsDataSuspenseQuery>;
export type ConfirmLineItemsDataQueryResult = Apollo.QueryResult<ConfirmLineItemsDataQuery, ConfirmLineItemsDataQueryVariables>;